import request from '@/utils/request'


// 菜品列表
export const getGoodsList = function (data) {
    return request({
        url: '/v1/food/getGoodsList',
        method: 'post',
        data: data
    })
}

// 菜品列表
export const getGoodComboList = function (data) {
    return request({
        url: '/v1/food/getGoodComboList',
        method: 'post',
        data: data
    })
}

export default {
    getGoodsList,
    getGoodComboList
}
